
    import {Component, Vue} from 'vue-property-decorator'
    import {Getter} from "vuex-class";
    import {addMerchantsLevel, addMerchantsTag, editMerchantsLevel, editMerchantsTag} from "@/api/customerManage";
    import TreeSelect from "@/components/TreeSelect/index.vue";
    import {GetGoodsCategoryList} from "@/api/commodity";
    import {categoryDto} from "@/api/goods";
    import {log} from "echarts/types/src/util/log";

    // levelType: string,
    // levelTypeName: string,

    interface LevelOption {
        levelId?: string,
        levelName: string,
        buyDiscount: string,
        selectStr:string,
        levelType:string,
        typeDtlList:Array<{ goodsType: string }>
    }

    @Component({
        name: 'LevelHandle',
        components: {TreeSelect}
    })
    export default class LevelHandle extends Vue {
        @Getter companyId!: string

        labelWidth = '8em'
        showClassify = false
        classifyList:Array<categoryDto> =[]
        formData: LevelOption = {
            levelName: '',
            buyDiscount: '',
            selectStr:'',
            levelType:'1',
            typeDtlList:[],
        }

        created () {
            if (this.$isEdit) {
                const data = JSON.parse(this.$route.query.data as string)
                this.formData.levelId = data.levelId
                this.formData.levelName = data.levelName
                this.formData.buyDiscount = data.buyDiscount
                this.formData.selectStr = data.levelTypeName
                this.formData.levelType=data.levelType
                this.formData.typeDtlList=data.typeDtlList
            }
            this.getGoodsCategoryList()
        }

        classifyConfirm (typeDtlList: any,selectStr:string,levelType:string) {
          this.showClassify = false;
          this.formData.typeDtlList=typeDtlList
          this.formData.selectStr=selectStr
          this.formData.levelType=levelType;
        }

      getGoodsCategoryList(){
        let params = {
          pageIndex: 1,
          categoryLevel: 0,
          pageSize: 10000,
          isPage: false
        }
        GetGoodsCategoryList(params).then(res=>{
          this.classifyList=res.data
          this.handelGoodsLevelTree(this.classifyList)
        })
      }

      /**
       * 处理商品分类成treeData的展示各式
       */

      handelGoodsLevelTree (data:Array<categoryDto>) {
        data.map(item => {
          item.isSelect =false
          if (item.children && item.children.length > 0) {
            this.handelGoodsLevelTree(item.children)
          }
        })
      }

        /**
         * 仅可录入0-100之间的正整数
         * @param val
         */
        formatterNumber (val: string) {
            if (val === '0') {
                return val
            } else {
                return Number(val) > 100 ? '100' : val.replace(/\b(0+)/gi,"")
            }
        }

        addSure() {
            (this.$refs.handleForm as any).validate().then(() => {
                if (this.$isEdit) {
                    editMerchantsLevel(this.formData).then(() => {
                        this.$toast.success({
                            message: '客户级别修改成功！',
                            duration: 1000,
                            onClose: () => {
                              setTimeout(()=>{
                                this.$router.back()
                              },200)
                            }
                        })
                    })
                } else {
                    addMerchantsLevel(this.formData).then((res) => {
                        this.$toast.success({
                            message: '客户级别新增成功！',
                            duration: 1000,
                            onClose: () => {
                              setTimeout(()=>{
                                if (this.$route.query.isAdd === '1') {
                                  this.$eventBus.$emit('levelAdd', res.data && res.data.id)
                                }
                                this.$router.back()
                              },200)
                            }
                        })
                    })
                }
            });
        }
        handleClose(){
          console.log(this.classifyList)
        }
    }
